export const DEFAULT_CALC = {
  targetAmount: '13200',
  initialAmount: '13200',
  annualIncreaseRate: '0',
  retirementAge: '19',
  monthlySavings: '1000',
}

export function propString(value, fallback) {
  if (value == null) return fallback
  const s = String(value).trim()
  return s === '' ? fallback : s
}
